// api/Universal

import request from '@utils/request'

const url = 'api/Universal/'

/**
 *
 * 获取时区（下拉框用）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetTimeZones (data) {
  return request({
    url: url + 'GetTimeZones',
    method: 'post',
    data
  })
}

/**
 *
 * 获取地址列表（下拉框用）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetAddresses (data) {
  return request({
    url: url + 'GetAddresses',
    method: 'post',
    data
  })
}

/**
 *
 * 获取货币单位列表（下拉框）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMonetarys (data) {
  return request({
    url: url + 'GetMonetarys',
    method: 'post',
    data
  })
}

/**
 *
 * 获取当前登录用户下的终端用户下拉列表（下拉框）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetMyTerminalsForSelect (data) {
  return request({
    url: url + 'GetMyTerminalsForSelect',
    method: 'post',
    data
  })
}

/**
 *
 * 获取当前登录用户的电站列表（通用，比如系统比较界面）
 * @export
 * @return {*}
 */
export function GetStationsForList () {
  return request({
    url: url + 'GetStationsForList',
    method: 'post',
  })
}

/**
 *获取组串和储能电站列表
 * @returns
 */
export function GetStringAndEnergyStorageStationsList () {
  return request({
    url: url + 'GetStringAndEnergyStorageStationsList',
    method: 'post'
  })
}

/**
 *
 * 安装商下拉
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryInstaller (data) {
  return request({
    url: url + 'QueryInstaller',
    method: 'post',
    data
  })
}

/**
 *
 * 根据电站获取采集器下拉列表（通用，比如气象站中有设备的下拉）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetGatewaysByOrgId (data) {
  return request({
    url: url + 'GetGatewaysByOrgId',
    method: 'post',
    data
  })
}

/**
 *
 * 根据电站获取设备列表（通用，比如电表的设备概览，和气象站一样默认是第一台设备的数据，需要用下拉框切换）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetDevicesByOrgId (data) {
  return request({
    url: url + 'GetDevicesByOrgId',
    method: 'post',
    data
  })
}

/**
 *
 * 获取萤石云播放地址
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetYsyPlayUrl (data) {
  return request({
    url: url + 'GetYsyPlayUrl',
    method: 'post',
    data
  })
}
